export default function AboutExpertSection() {
  return (
    <section id="about" className="py-20 md:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-12 items-center max-w-6xl mx-auto">
          {/* Photo */}
          <div>
            <div className="w-full h-[400px] md:h-[500px] rounded-2xl overflow-hidden shadow-xl">
              <img
                src="https://static.readdy.ai/image/045fa1b133efd9567759baab28602a6d/d5f5f47c7d94e3dc67c5ef073553230f.jpeg"
                alt="Алексей Сивко — бизнес-тренер и эксперт по корпоративному обучению"
                title="Алексей Сивко — эксперт по корпоративному обучению"
                className="w-full h-full object-cover md:object-[center_20%] object-top"
              />
            </div>
          </div>

          {/* Info */}
          <div>
            <h2 className="text-3xl md:text-4xl font-extrabold text-gray-900 mb-4">Алексей Сивко</h2>
            <p className="text-xl text-teal-600 font-semibold mb-6">
              <a href="https://sivko.by/" target="_blank" rel="noopener noreferrer" className="hover:text-teal-700 transition-colors">Бизнес-тренер</a> с более чем 18-летним опытом в продажах и переговорах
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                <p className="text-gray-700 leading-relaxed">
                  Провёл <strong>сотни корпоративных тренингов</strong> для руководителей и команд в Беларуси, России, Казахстане и Израиле
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Эксперт по корпоративным продажам</strong>, переговорам, soft skills и командообразованию. Автор концепции «Культурология продаж»
                </p>
              </div>
              <div className="flex items-start gap-3">
                <i className="ri-check-line text-2xl text-teal-600 mt-1"></i>
                <p className="text-gray-700 leading-relaxed">
                  <strong>Сертифицированный бизнес-тренер</strong> с международными квалификациями. Постоянно совершенствует методики обучения
                </p>
              </div>
            </div>

            {/* Key stats */}
            <div className="grid grid-cols-2 gap-4">
              {[
                { value: '100+', label: 'корпоративных проектов' },
                { value: '450+', label: 'тренингов и сессий' },
                { value: '4500+', label: 'участников обучено' },
                { value: '4', label: 'страны присутствия' },
              ].map((stat) => (
                <div key={stat.label} className="bg-gray-50 rounded-xl p-4 border border-gray-100 text-center">
                  <div className="text-2xl font-extrabold text-teal-600">{stat.value}</div>
                  <div className="text-xs text-gray-500 mt-1">{stat.label}</div>
                </div>
              ))}
            </div>

            {/* Quote */}
            <div className="mt-6 bg-gray-50 p-5 rounded-xl border-l-4 border-teal-600">
              <p className="text-gray-700 italic leading-relaxed text-sm">
                «Моя цель — не просто передать знания, а помочь каждому участнику раскрыть свой потенциал и достичь конкретных результатов в бизнесе. Эффективное обучение — это практика, обратная связь и постоянное развитие.»
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}